import { isLoggedIn } from 'utils/auth'
import {injectReducer} from '../../store/reducers'
import {fetchOrderDetailReducer} from './modules/orderDetails'

export default (store) => ({
  path: 'order-details/:orderId',
  isPrintView: true,
  onEnter: isLoggedIn(store),
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      const OrderDetailsContainer = require('./containers/orderDetailsContainer').default

      injectReducer(store, { key: 'order', reducer: fetchOrderDetailReducer })
      cb(null, OrderDetailsContainer)
    })
  }
})



// WEBPACK FOOTER //
// ./src/routes/OrderDetails/index.js